import { Crisp } from 'crisp-sdk-web'
import Vue from 'vue'

Crisp.configure('d39c2b38-d632-43b8-9e90-bf03b7a0deac', {
  autoload: false
})

// The CAI chatbot lives under /chatbot and /chatbot/settings. Crisp is the
// portal-wide support chat and its launcher sits in the same bottom-right
// corner, so keep it out of the way while the user is in our own chat.
export const hidesCrisp = path => /^\/chatbot(\/|$)/.test(path || '')

// Both chat.show() and chat.hide() inject the Crisp script when it has not
// been loaded yet, so only touch the launcher once something else loaded it
// (App.vue / LoginForm do that for signed-in users).
export const syncCrispVisibility = path => {
  if (!Crisp.isCrispInjected()) {
    return
  }

  if (hidesCrisp(path)) {
    Crisp.chat.hide()
  } else if (localStorage.getItem('user')) {
    Crisp.chat.show()
  }
}

Vue.prototype.$crisp = Crisp
